var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"terms-conditions__container"},[_c('iframe',{attrs:{"srcdoc":_vm.licenseAgreementHtml}})])
}
var staticRenderFns = []

export { render, staticRenderFns }